import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem, i as isNodeEnvironment, g as global$1 } from './p-g1JgJ7wn.js';
import { i as isInteractiveTarget, u as updateSlottedAppearance, d as defineCustomElement$9 } from './p-C_UAOMqO.js';
import { r as resolveAppearance } from './p-CkrRd9Ud.js';
import { d as defineCustomElement$8 } from './p-B77_NHv6.js';
import { d as defineCustomElement$7 } from './p-DM62vhwv.js';
import { d as defineCustomElement$6 } from './p-SHLJjLOh.js';
import { d as defineCustomElement$5 } from './p-Wm3pAWRJ.js';
import { d as defineCustomElement$4 } from './p-DZLtnVbO.js';
import { d as defineCustomElement$3 } from './p-HrLUFnJX.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosFloatingBarCss = ":host{--cosmos-bottom-sheet-border-radius:var(--cosmos-floating-bar-border-radius) var(--cosmos-floating-bar-border-radius)\n    0 0;--cosmos-bottom-sheet-border-width:var(--cosmos-floating-bar-border-width);--cosmos-bottom-sheet-border-color:var(--cosmos-floating-bar-border-color);--cosmos-bottom-sheet-box-shadow:var(--cosmos-floating-bar-box-shadow);--cosmos-bottom-sheet-background-collapsed:var(--cosmos-floating-bar-background-collapsed);--cosmos-bottom-sheet-background-expanded:var(--cosmos-floating-bar-background-expanded)}.cosmos-floating-bar{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:var(--cosmos-floating-bar-background-expanded, #FFFFFF);border:var(--cosmos-floating-bar-border-width, 1px) solid var(--cosmos-floating-bar-border-color, rgba(0, 15, 30, 0.1));border-radius:var(--cosmos-floating-bar-border-radius, 8px);bottom:var(--cosmos-floating-bar-bottom-offset, 32px);box-shadow:var(--cosmos-floating-bar-box-shadow, 0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431));box-sizing:border-box;display:grid;grid-template-rows:auto 0fr;max-height:calc(85vh - 64px);max-width:560px;position:fixed;text-align:start;transform:translateY(0);transition:background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 250ms linear, -webkit-backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1);transition:backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1), background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 250ms linear;transition:backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1), background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 250ms linear, -webkit-backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1);width:420px;will-change:transform, grid-template-rows, backdrop-filter, background;z-index:1000}.cosmos-floating-bar--collapsed{background:var(--cosmos-floating-bar-background-collapsed, rgba(255, 255, 255, 0.9))}.cosmos-floating-bar--expanded{grid-template-rows:auto 1fr}.cosmos-floating-bar--hidden{transform:translateY(calc(100% + 32px));transition:background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 0s linear 250ms, -webkit-backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1);transition:backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1), background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 0s linear 250ms;transition:backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1), background 250ms cubic-bezier(0.32, 0, 0.32, 1), border-color 250ms cubic-bezier(0.32, 0, 0.32, 1), box-shadow 250ms cubic-bezier(0.32, 0, 0.32, 1), grid-template-rows 300ms cubic-bezier(0.42, 0, 0.58, 1), transform 250ms cubic-bezier(0.32, 0, 0.32, 1), visibility 0s linear 250ms, -webkit-backdrop-filter 250ms cubic-bezier(0.32, 0, 0.32, 1);visibility:hidden}@media (hover: hover){.cosmos-floating-bar--expandable:hover{border-color:var(--cosmos-floating-bar-border-color-hover, rgba(0, 15, 30, 0.2));box-shadow:var(--cosmos-floating-bar-box-shadow-hover, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431))}}.cosmos-floating-bar--expandable:focus-within{border-color:var(--cosmos-floating-bar-border-color-hover, rgba(0, 15, 30, 0.2));box-shadow:var(--cosmos-floating-bar-box-shadow-hover, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431))}@media (hover: hover){.cosmos-floating-bar--expandable.cosmos-floating-bar--appearance-dark:hover{border-color:var(--cosmos-floating-bar-border-color-hover, rgba(255, 255, 255, 0.45))}}.cosmos-floating-bar--expandable.cosmos-floating-bar--appearance-dark:focus-within{border-color:var(--cosmos-floating-bar-border-color-hover, rgba(255, 255, 255, 0.45))}.cosmos-floating-bar--align-center{inset-inline:0;margin-inline:auto}.cosmos-floating-bar--align-start{inset-inline-start:var(--cosmos-floating-bar-inline-offset, 32px)}.cosmos-floating-bar--align-end{inset-inline-end:var(--cosmos-floating-bar-inline-offset, 32px)}.cosmos-floating-bar--fit-content{width:max-content}.cosmos-floating-bar--appearance-dark{background:var(--cosmos-floating-bar-background-expanded, #000F1E);border-color:var(--cosmos-floating-bar-border-color, rgba(255, 255, 255, 0.2))}.cosmos-floating-bar--appearance-dark.cosmos-floating-bar--collapsed{background:var(--cosmos-floating-bar-background-collapsed, rgba(0, 15, 30, 0.8))}.cosmos-floating-bar__mode{display:contents}.cosmos-floating-bar__header{all:unset;}.cosmos-floating-bar__header{box-sizing:border-box;cursor:default;position:relative;-webkit-user-select:none;user-select:none}.cosmos-floating-bar--expanded .cosmos-floating-bar__header{border-radius:8px 8px 0 0}.cosmos-floating-bar--expandable .cosmos-floating-bar__header{cursor:pointer}.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus,.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus:not(:focus-visible){outline:none}.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus:not(:focus-visible)::before{content:none}.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus::before{border-radius:calc(8px * 1.5);bottom:calc((4px + 2px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 2px) * -1);position:absolute;right:calc((4px + 2px) * -1);top:calc((4px + 2px) * -1);content:\"\"}.cosmos-floating-bar--expanded.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus,.cosmos-floating-bar--expanded.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus:not(:focus-visible){outline:none}.cosmos-floating-bar--expanded.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus:not(:focus-visible)::before{content:none}.cosmos-floating-bar--expanded.cosmos-floating-bar--expandable .cosmos-floating-bar__header:focus::before{border-radius:calc(8px * 1.5) calc(8px * 1.5) 0 0;bottom:calc((4px + -5px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 2px) * -1);position:absolute;right:calc((4px + 2px) * -1);top:calc((4px + 2px) * -1);content:\"\"}.cosmos-floating-bar__header-inner{align-items:center;box-sizing:border-box;display:grid;gap:8px;grid-template-rows:calc(64px - 1px * 2 - 12px * 2);overflow:hidden;padding-block:12px;padding-inline:16px}.cosmos-floating-bar--expandable .cosmos-floating-bar__header-inner{grid-template-columns:auto 36px}.cosmos-floating-bar__header-collapsed,.cosmos-floating-bar__header-expanded{grid-column:1;grid-row:1;min-width:0}.cosmos-floating-bar__header-collapsed{opacity:1;transition:opacity 250ms cubic-bezier(0.32, 0, 0.32, 1)}.cosmos-floating-bar--expanded .cosmos-floating-bar__header-collapsed{opacity:0;pointer-events:none}.cosmos-floating-bar__header-expanded{display:flex;opacity:0;pointer-events:none;transition:opacity 250ms cubic-bezier(0.32, 0, 0.32, 1)}.cosmos-floating-bar--expanded .cosmos-floating-bar__header-expanded{opacity:1}.cosmos-floating-bar__body{border-radius:0 0 8px 8px;min-height:0;overflow:hidden}.cosmos-floating-bar__body-inner{box-sizing:border-box;color-scheme:light;height:100%;overflow:hidden;overscroll-behavior:contain;padding:0 16px 16px}.cosmos-floating-bar--appearance-dark .cosmos-floating-bar__body-inner{color-scheme:dark}.cosmos-floating-bar--expanded .cosmos-floating-bar__body-inner{animation:show-body-overflow 0s linear 300ms forwards}@keyframes show-body-overflow{to{overflow-y:auto}}.cosmos-floating-bar__slot-wrapper{display:contents}.cosmos-floating-bar__slot-wrapper[slot=header-collapsed] ::slotted(*),.cosmos-floating-bar__slot-wrapper[slot=header-expanded] ::slotted(*){max-width:100%;min-width:0;width:100%}.cosmos-floating-bar__slot-wrapper[slot=body] ::slotted(*){min-width:100%;width:0}.cosmos-floating-bar ::slotted([slot=header-collapsed]),.cosmos-floating-bar ::slotted([slot=header-expanded]){max-width:100%;min-width:0;width:100%}.cosmos-floating-bar ::slotted([slot=body]){min-width:100%;width:0}@media (prefers-reduced-motion: reduce){.cosmos-floating-bar{transition-duration:0.001ms}}";

const CosmosFloatingBar$1 = /*@__PURE__*/ proxyCustomElement(class CosmosFloatingBar extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Positions the component horizontally on desktop using 'start', 'center', or 'end', with automatic RTL support where 'start' and 'end' adapt to text direction. Viewports below 1000px always center the component.
         */
        this.align = 'center';
        /**
         * Toggles the visibility of the expand button (drag handle on mobile). Also enables expand/collapse functionality and drag gestures on mobile. When set to 'false', the sheet remains fixed in a collapsed state.
         */
        this.expandable = false;
        /**
         * When true, component width hugs content up to maximum of 560px. When false, uses fixed width of 420px. Only applies when the viewport is ≥1000px.
         */
        this.fitContent = false;
        /**
         * Controls the visibility of the floating bar. When false, the component slides out of view.
         */
        this.visible = true;
        this.computedAppearance = 'light';
        this.isExpanded = false;
        this.isMobile = false;
        this.generateClassNames = bem('cosmos-floating-bar');
        this.KEYS = {
            ENTER: 'Enter',
            ESCAPE: 'Escape',
            SPACE: ' ',
        };
        this.MOBILE_BREAKPOINT = 1000;
        this.handleHeaderClick = (event) => {
            if (!this.expandable || isInteractiveTarget(event)) {
                return;
            }
            this.toggleExpanded();
        };
        this.handleHeaderKeyDown = (event) => {
            if (!this.expandable) {
                return;
            }
            if (event.key === this.KEYS.ENTER || event.key === this.KEYS.SPACE) {
                if (!isInteractiveTarget(event)) {
                    event.preventDefault();
                    this.toggleExpanded();
                }
            }
        };
        this.getExpandedAriaValue = () => (this.expandable ? String(this.isExpanded) : undefined);
        this.getControlsAriaValue = () => (this.expandable ? 'floating-bar-body' : undefined);
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
        updateSlottedAppearance(this.element, appearance);
    }
    handleVisibleChange(visible) {
        if (!visible) {
            this.isExpanded = false;
        }
    }
    handleResize() {
        this.updateMobileState();
    }
    handleKeyDown(event) {
        if (this.expandable && this.isExpanded && event.key === this.KEYS.ESCAPE) {
            this.isExpanded = false;
        }
    }
    /**
     * Programmatically expands the floating bar.
     * Only works when `expandable` is true and `visible` is true.
     */
    async expand() {
        if (!this.expandable || !this.visible) {
            return;
        }
        if (this.isMobile && this.bottomSheetRef) {
            await this.bottomSheetRef.expand();
            return;
        }
        if (!this.isExpanded) {
            this.isExpanded = true;
        }
    }
    /**
     * Programmatically collapses the floating bar.
     * Only works when `expandable` is true and `visible` is true.
     */
    async collapse() {
        if (!this.expandable || !this.visible) {
            return;
        }
        if (this.isMobile && this.bottomSheetRef) {
            await this.bottomSheetRef.collapse();
            return;
        }
        if (this.isExpanded) {
            this.isExpanded = false;
        }
    }
    updateMobileState() {
        if (isNodeEnvironment()) {
            return;
        }
        this.isMobile = global$1.window.innerWidth < this.MOBILE_BREAKPOINT;
    }
    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
    }
    renderChevron() {
        return (h("cosmos-button", { class: this.generateClassNames('expand-toggle'), decorative: true, kind: "bare", shape: "circle", size: "small" }, this.isExpanded ? h("cosmos-icon-chevron-down", { slot: "icon" }) : h("cosmos-icon-chevron-up", { slot: "icon" })));
    }
    renderHeader() {
        const headerInner = (h("div", { class: this.generateClassNames('header-inner') }, h("div", { class: this.generateClassNames('header-collapsed'), inert: this.isExpanded }, h("slot", { name: "header-collapsed" })), h("div", { class: this.generateClassNames('header-expanded'), inert: !this.isExpanded }, h("slot", { name: "header-expanded" })), this.expandable && this.renderChevron()));
        if (this.expandable) {
            return (h("button", { "aria-controls": this.getControlsAriaValue(), "aria-expanded": this.getExpandedAriaValue(), "aria-label": this.isExpanded ? 'Collapse content' : 'Expand content', class: this.generateClassNames('header'), onClick: this.handleHeaderClick, onKeyDown: this.handleHeaderKeyDown }, headerInner));
        }
        return h("div", { class: this.generateClassNames('header') }, headerInner);
    }
    renderBody() {
        return (h("div", { class: this.generateClassNames('body'), id: "floating-bar-body", inert: !this.isExpanded }, h("div", { class: this.generateClassNames('body-inner') }, h("div", null, h("slot", { name: "body" })))));
    }
    renderBottomSheet() {
        return (h("cosmos-bottom-sheet", { appearance: this.computedAppearance, expandable: this.expandable, ref: (el) => (this.bottomSheetRef = el), visible: this.visible }, h("div", { class: this.generateClassNames('slot-wrapper'), slot: "header-collapsed" }, h("slot", { name: "header-collapsed" })), h("div", { class: this.generateClassNames('slot-wrapper'), slot: "header-expanded" }, h("slot", { name: "header-expanded" })), h("div", { class: this.generateClassNames('slot-wrapper'), slot: "body" }, h("slot", { name: "body" }))));
    }
    renderFloatingBar() {
        const classes = this.generateClassNames({
            'align': this.align,
            'appearance': this.computedAppearance,
            'collapsed': !this.isExpanded,
            'expandable': this.expandable,
            'expanded': this.isExpanded,
            'fit-content': this.fitContent,
            'hidden': !this.visible,
            'visible': this.visible,
        });
        return (h("div", { class: classes, inert: !this.visible }, h("cosmos-mode", { class: "cosmos-floating-bar__mode", mode: this.computedAppearance }, this.renderHeader(), this.renderBody())));
    }
    componentWillLoad() {
        this.updateMobileState();
        resolveAppearance({
            callback: this.handleAppearanceChange.bind(this),
            instance: this,
            modeToAppearanceMap: { dark: 'dark', light: 'light' },
        });
    }
    componentDidLoad() {
        updateSlottedAppearance(this.element, this.computedAppearance);
    }
    render() {
        return h(Host, { key: '7d18be3925393401b332a7331ce5ad9ffc1d80bc' }, this.isMobile ? this.renderBottomSheet() : this.renderFloatingBar());
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"],
        "visible": ["handleVisibleChange"]
    }; }
    static get style() { return cosmosFloatingBarCss; }
}, [1, "cosmos-floating-bar", {
        "align": [513],
        "appearance": [513],
        "expandable": [516],
        "fitContent": [516, "fit-content"],
        "visible": [516],
        "computedAppearance": [32],
        "isExpanded": [32],
        "isMobile": [32],
        "expand": [64],
        "collapse": [64]
    }, [[9, "resize", "handleResize"], [0, "keydown", "handleKeyDown"]], {
        "appearance": ["handleAppearanceChange"],
        "visible": ["handleVisibleChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-floating-bar", "cosmos-bottom-sheet", "cosmos-button", "cosmos-icon-chevron-down", "cosmos-icon-chevron-up", "cosmos-icon-close-small", "cosmos-mode", "cosmos-spinner", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-floating-bar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosFloatingBar$1);
            }
            break;
        case "cosmos-bottom-sheet":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "cosmos-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "cosmos-icon-chevron-down":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "cosmos-icon-chevron-up":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "cosmos-icon-close-small":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-mode":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-spinner":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosFloatingBar = CosmosFloatingBar$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosFloatingBar, defineCustomElement };
